import { SettingsPageFrame } from '@eluve/blocks';

import { TenantUserSnippetsList } from '../../TenantUserSnippetsList';

export const ShortcutsSettingsPage: React.FC = () => (
  <SettingsPageFrame title="Shortcuts">
    <TenantUserSnippetsList />
  </SettingsPageFrame>
);
